"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@material-ui/core");
var AutoComplete_1 = __importDefault(require("../components/AutoComplete"));
var functions_1 = require("../functions");
var useAutoComplete_1 = __importDefault(require("../functions/useAutoComplete"));
var useStyles = core_1.makeStyles({
    root: {
        position: 'relative',
    },
    resultListPart: {
        top: 48,
        left: 0,
        position: 'absolute',
        zIndex: 10,
    }
});
function AutoCompleteContainer(props) {
    var classes = useStyles();
    var valueResultList = props.valueResultList;
    var lastIndex = valueResultList.length - 1;
    var _a = useAutoComplete_1.default(props), isShowResult = _a.isShowResult, handleSelectResult = _a.handleSelectResult, handleSelectResultDirectly = _a.handleSelectResultDirectly, handleCloseResultList = _a.handleCloseResultList, handleChange = _a.handleChange;
    var index = functions_1.useFnsByKeyCode({
        lastIndex: lastIndex,
        confirmFn: handleSelectResult,
        escapeFn: handleCloseResultList
    }).index;
    return (react_1.default.createElement(AutoComplete_1.default, __assign({}, props, { onSelectValueResult: handleSelectResultDirectly, closeResultListFn: handleCloseResultList, onChange: handleChange, isShowResult: isShowResult, selectedIndex: index })));
}
;
exports.default = AutoCompleteContainer;
